<template>

    <!-- page content -->
	<div class="container-fluid">
        <div class="row">
			<div class="col-lg-6 col-md-12 col-sm-12 mx-auto mt-5 mb-5">

                <div class="row">
                    <div class="col">
                        <h3>Open a Support Ticket</h3>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col">
                        <div class="panel p-3">

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Select a Category</label>
                                        <select class="form-control" v-model="ticketData.category">
                                            <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Select a Priority</label>
                                        <select class="form-control" v-model="ticketData.priority">
                                            <option value="Low">Low</option>
                                            <option value="Medium">Medium</option>
                                            <option value="High">High</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="title">Ticket Title</label>
                                <input type="text" class="form-control" id="title" v-model="ticketData.title">
                            </div>

                            <div class="form-group">
                                <label for="message">Message</label>
                                <textarea class="form-control" id="message" v-model="ticketData.message" rows="10"></textarea>
                            </div>

                            <div class="form-group mb-0 mt-4 text-center">
                                <button class="btn btn-primary btn-block" v-on:click="addTicket">Create Ticket</button>
                            </div>
                            
                        </div>
                    </div>
                </div>

			</div>
		</div>

		
	</div>

</template>

<script>

    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'Support',
		data () {
			return {
                ticketData: {
                    category: null,
                    title: null,
                    priority: "Low",
                    message: null,
                },
                categories: [],
			}
        },
		mounted() {
            this.getTicketCategories();
        },  
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getTicketCategories() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/support/tickets/categories", this.getAuthorizationHeader()).then((response) => {
                    _this.categories = response.data
                });
            },
            addTicket() {
                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/support/tickets/new", this.ticketData, this.getAuthorizationHeader()).then((response) => {
                    if(response.data[0] == 'success') {
                        _this.$router.push({ name: 'StringerSupportTickets'})
                    }
                });

            }
        },
		
	}
</script>

<style scoped>

    .panel {
		background-color: #fff;
		padding: 0px;
    }

</style>
